
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m504 255.5c.3 136.6-111.2 248.4-247.8 248.5-64 0-122.4-24.2-166.4-63.9-5.1-4.6-5.3-12.5-.4-17.4l17-17c4.5-4.5 11.8-4.7 16.6-.4 35.2 31.5 81.8 50.7 133 50.7 110.5 0 200-89.5 200-200s-89.5-200-200-200c-55.5 0-105.7 22.6-141.9 59l49.1 48.4c7.6 7.5 2.3 20.5-8.4 20.5h-128.4c-6.6 0-12-5.4-12-12v-126.5c0-10.7 12.8-16 20.4-8.5l45.1 44.5c45-45.3 107.3-73.4 176.1-73.4 136.8 0 247.7 110.8 248 247.5zm-167.1 90.2 14.1-19.4c3.9-5.4 2.7-12.9-2.6-16.8l-68.4-49.7v-143.8c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v168.2l88.2 64.1c5.4 3.9 12.9 2.7 16.8-2.6z"}})])
          )
        }
      }
    